import { FC, MouseEventHandler, ReactNode } from 'react'

import { Button } from '@/components/atoms/Button'
import { ButtonProps } from '@/components/atoms/Button/Button'
interface SubscribeButtonProps {
  onClick: MouseEventHandler<HTMLIonFabButtonElement | HTMLIonButtonElement>
  children: ReactNode
  className?: string
  type?: ButtonProps['type']
  disabled?: boolean
}

export const SubscribeButton: FC<SubscribeButtonProps> = ({
  children,
  className,
  type = 'primary',
  disabled = false,
  onClick,
}) => {
  return (
    <>
      <Button
        onClick={onClick}
        className={`mx-auto ${className}`}
        isDisabled={disabled}
        type={type}
      >
        {children}
      </Button>
    </>
  )
}
